'use strict';

var React = require('react');

var SvgTransactionFeePoundMajor = function SvgTransactionFeePoundMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11 13a1 1 0 0 1 0 2c-2.206 0-4-1.794-4-4v-7h-1.184a2.997 2.997 0 0 1-2.816 2c-1.654 0-3-1.346-3-3s1.346-3 3-3c1.302 0 2.401.839 2.816 2h8.368a2.997 2.997 0 0 1 2.816-2c1.654 0 3 1.346 3 3s-1.346 3-3 3a2.995 2.995 0 0 1-2.815-2h-5.185v7c0 1.103.897 2 2 2zm3.244 3h-.244a1 1 0 0 1 0-2h.472c.019-.34.028-.682.028-1.027 0-1.894 1.057-3.246 2.555-3.483 1.504-.239 2.867.785 2.867 2.4a1 1 0 0 1-2 0c0-.323-.21-.48-.555-.425-.487.077-.867.563-.867 1.508 0 .345-.009.687-.026 1.027h1.526a1 1 0 0 1 0 2h-1.73a18.706 18.706 0 0 1-.422 2h2.652a1 1 0 0 1 0 2h-4a1 1 0 0 1-1-1 .999.999 0 0 1 .056-.354c.302-.86.53-1.742.688-2.646z"
  }));
};

exports.SvgTransactionFeePoundMajor = SvgTransactionFeePoundMajor;
